import { createAction } from 'redux-actions';

export const clearOnHoldReservations = createAction(
  'CLEAR_ON_HOLD_RESERVATIONS'
);

export const onHoldReservationsOnChangePage = createAction(
  'ON_HOLD_RESERVATIONS_ON_CHANGE_PAGE'
);

export const onHoldReservationsOnChangeOrder = createAction(
  'ON_HOLD_RESERVATIONS_ON_CHANGE_ORDER'
);
